<template>
  <TheHeader bgClass="header-bg-color" fontClass="fontColor2"/>

  <div class="about-content-wrapper montserrat-400 sub-text-one">
    <ThePageSubTitle titleMsg="About Us"  msg="A Visual Insight into Who We Are"/>
    <br/>
    <br/>

    <div class="text-wrap">
      <span class="poppins-bold">HISTORY</span>      
      <br/>
      Shortage of wire rope for mobile crane back in the 1970s caught the industry players off-handed and had to try 
      all means to solve the problem but was still in vain. Although there was factory manufacturing wire rope in the 
      country at that time but the product was not meant for heavy duty. They approached the officers in the Ministry of 
      International Trade and Industry to seek assistance and were told that import of heavy duty wire rope from Singapore 
      would on be only permitted on the request from organized bodies. Finally, some of these mobile crane owners joined 
      as members of the Lorry Transport Association for the region of KL Selangor, and through this Association that the problem 
      of wire rope shortage was eventually solved.
      <br/>
      <br/>
      incident brought awareness to the mobile crane owners that only when they themselves were organized would they have 
      the power to negotiate with relevant parties for the benefits of their own industry. With such a thought in mind, 
      the mobile crane owners started to come together and brought about Malaysia Mobile Crane Owners Association into existence!
      <br/>
      <br/>
      Malaysia Mobile Crane Owners Association was registered as a national organization. At a time when transportation and 
      communication were still not as easy as today, keeping the members from all over the country in contact was a difficult job. 
      Under such conditions, when time came for calling a General Meeting and getting a valid quorum was a huge task for the 
      Management Committee.
      <br/>
      <br/>
      In the 70s, most of the Committee Members were still struggling with their own businesses and could not spare much time and money 
      helping the operation of the organization. Moreover, with the least knowledge of the Societies Act, Malaysia Mobile Crane Owners 
      Association was deregistered because of non-compliance to the procedure of the Registrar of Society!
      <br/>
      <br/>
      In year 1987, under the leadership of the late Mr. Liew Fatt, submission was made to re-register the Malaysia Mobile Crane 
      Owners Association. Several visits to the office in the Registrar of Society’s office in Kuala Lumpur were organized and finally 
      with the assistance from the then Deputy Minister of Internal Trade and Consumer Affairs of Malaysia, Dato’ Tan Chai Ho, approval was 
      obtained in early 1989 and the organization was re-registered with the name of “Malaysia Mobile Crane Owners Association (1987)”.
      <br/>
      <br/>
      Fatt was elected as the first President of the newly re-registered organization and served for the following decade leading the 
      MMCOA (1987) moving forward. During the term of his office, the Association raised fund to purchase a shop-let unit at Entrepreneur 
      Park in Kepong Kuala Lumpur to make it the office for the daily operation of the Association.
      <br/>
      <br/>
      In 2011, a resolution was passed in the AGM to acquire a 3-storey shop lot in Balakong Jaya to make it the new office of the Association 
      and part of the building to be rented out to generate a steady source of income for the Association.
      <br/>
      <br/>
      The fund raising campaign started with the Management Committee members where the President alongside with most of the committee members 
      donated to start the ball rolling. The members of the fund raising sub-committee travelled throughout the country to meet fellow industry 
      players to seek contribution for the purchase of the new building. Although the campaign was well-received by fellow industry players, 
      the amount of donation collected was not sufficient to pay for the purchase price of the building. The Management Committee had to negotiate 
      for friendly loans from some the committee members and with their generosity, the purchase was completed.
      <br/>
      <br/>
      MMCOA (1987) moved to the new office in mid-2012, and has been operating to this day.
      <br/>
      <br/>
      <span class="poppins-bold">INTRODUCTION</span>  
      <br/>
      Members of MMCOA (1987) mainly consist of all the owners of mobile cranes, crawler cranes and sky lifts in the country. In 
      recent years, the membership had been extended to the supply chain such as manufacturer, dealers, spare parts suppliers and etc.
      <br/>
      <br/>
      Members of the association are mainly from the Klang Valley and affiliated with others states in the Southern region namely Johor 
      Mobile Crane Owners’ Association (JMCOA), Mobile Crane Association North Malaysia from Northern region, East coast and East Malaysia 
      crane owners’ representatives. We represent about 600 companies in total and our employees are mainly local citizens.  
      <br/>
      <br/>
      Our function are mainly involves in dealing with the problem faced by the industry with government agencies such as JPJ issues, 
      inspection via Puspakom, issues regarding to competency of certification with DOSH (JKKP), training of workforce for the industry 
      with CIDB, workers problem with Human Resource Ministry, financing matter with Ministry of Finance and many other more.  
      <br/>
      <br/>
      Other than that we also organize events such as seminar talks, annual dinners, moon cakes festival, scholarship giving out to 
      outstanding students, crane operator competition and outing to overseas country for knowledge exchange and factory visits.
      <br/>
      <br/>
      We had even extended our connection to overseas where Kaohsiung Crane Association, Taipei County Construction Machine Association, 
      Taiwan Construction Machine Association, Tao Yuan City Construction Machine Association are our Sisters Associations.
      <br/>
      <br/>
      Our industry involves in supporting services in several key critical sectors involving and play important roles in the infrastructure, 
      power generation, oil and gas, port and logistic, petrochemical industry, construction industry sector and etc.
      <br/>
      <br/>
    </div>
    
    ------------------
    <br/>
    <br/>

    <div class="text-wrap">
      马来西亚吊秤车同业公会 (1987)
      <br/>
      公会历史与简介
      <br/>
      <br/>
      <span class="poppins-bold">历史</span>
      <br/>
      在1970年代，发生了吊秤用途钢索短缺的事件，让当时的吊秤服务业者不知所措。虽然当时国内的制造商也有生产钢索，但只供一般普通用途。为了解除困境，约见了贸工部的官员寻求援助。
      根据条例，只有通过组织团体才准从国外入口所需的钢索。在别无选择之下，一些业者加入雪隆啰里公会成为会员，这样才解决了钢索短缺的难题。
      <br/>
      <br/>
      这件事情让吊秤服务的业者们看到了一个事实：“求人不如求己，团结才有力量”。大家知道把力量凝集起来，才能够和政府相关部门洽谈事务及维护业者应有的权益。本着这个观念以及一些同业召唤之下，成立了马来西亚吊秤车公会！
      <br/>
      <br/>
      当年同业们以“马来西亚吊秤车公会”的名称注册成功！但是，作为一个全国性组织，在一个通讯与交通系统尚不发达的年代是需要面对很多艰巨的挑战的。召集会员开会就是一个大考验。
      由于当年缺乏对社团法令的认知以及缺乏社团运作的经验，再加上70年代是大家都在血拼的年代；公会因没有依照社团注册局的标准操作程序而被冻结了注册。
      <br/>
      <br/>
      在1987年，在已故刘发先生的带领下成立了一个新的筹委会，重新向社团注册局提出申请注册。经过多番努力及得到当时任职国内贸易及消费人事务部政务次长的拿督陈财和从旁协调，
      社团注册局在1989年初正式批了“马来西亚吊秤车同业公会（1987）”。已故刘发被推选为重新注册后的第一届理事会主席，领导着同业们与政府部门展开协调会议，为维护同业们的权益据理力争。
      <br/>
      <br/>
      公会于1996年成功在Kepong买下了属于自己的会所。
      <br/>
      <br/>
      2011的会员大会通过了一项议案，让公会在无拉港再也购买一棟三层楼建筑。除了作为公会的永久营运办事处之外，也出租建筑的部分，把租金作为收入，希望达到以会养会的目的。
      <br/>
      <br/>
      筹募购置会所基金的行动从理事会开始并得到大多数理事的支持而启动了筹募基金的活动。筹募基金小组的成员们不辞劳苦，南下北上会见同业，征求他们给予公会经济上的支持。
      <br/>
      <br/>
      虽然筹款活动一般上获得同业施以援手，但是筹获的款项距离买楼的数目仍有一段距离。理事会只好向一些理事提出“友善借贷”的建议，幸好获得这些理事慷慨协助解决了这个窘境，终于成功买下了这栋三楼建筑物。
      <br/>
      <br/>
      2012年中旬，马来西亚吊秤车同业公会（1987）正式迁入新的会所，一直运作至今。
      <br/>
      <br/>
      <span class="poppins-bold">简介</span>
      <br/>
      马来西亚吊秤车同业公会（1987）公会的成员架构主要由国内的移动式起重机，履带式起重机和高空升降作业车的业者所组成。近年来，入会资格已扩展至行业相关供应链，如制造商、经销商、备件供应商等。
      <br/>
      <br/>
      马来西亚吊秤车同业公会 (1987) 的会员主要来自巴生谷，其他州如南部地区的柔佛州吊秤车同业公会、北部地区的北马吊车同业公会、东海岸和东马吊车同业代表则为公会附属机构。 我们总共代表了大约600家公司，而其员工主要为当地公民。
      <br/>
      <br/>
      公会的功能主要涉及与政府机构处理行业所面临的问题，如陆路交通局 (JPJ) 的课题、通过电脑验车中心 (PUSPAKOM) 进行检验、有关职业安全与卫生局 (JKKP) 技能认证的问题、与大马建筑工业发展局 (CIDB) 合作为行业培训劳动力、通过人力资源部解决劳工问题，与财政部解决财务事宜等等。
      <br/>
      <br/>
      除此之外，我们还举办诸如研讨会讲座、周年晚宴、中秋节、优秀学生奖学金、起重机操作员比赛以及到海外进行知识交流和参观工厂等活动。
      <br/>
      <br/>
      我们甚至把联系扩展到海外，台湾高雄市起重机具协会、台湾新北市建设机械商业同业公会、台湾建设机械协会、台湾桃园市起重机商业同业公会皆是与公会缔结的姐妹会。
      <br/>
      <br/>
      我们的行业涉及在基础设施、发电、油气、港口和物流、石油化工、建筑业等多个关键领域，并在这些领域发挥极为重要的作用。
      <br/>
      <br/>
    </div>

  </div>

  <TheSponsor bgClass="header-bg-color"/>

   <!-- Copyright -->
   <TheCopyRight/>
</template>

<script>
// @ is an alias to /src
import TheHeader from '@/components/TheHeader.vue'
import TheSponsor from '@/components/TheSponsor.vue'
import TheCopyRight from '@/components/TheCopyRight.vue'
import ThePageSubTitle from '@/components/ThePageSubTitle.vue'

export default {
  name: 'About Us',
  components: {
    TheHeader,
    TheSponsor,
    TheCopyRight,
    ThePageSubTitle
  }
}
</script>

<style scoped>
.about-content-wrapper {
  color: #666666;
  text-align: center;
}

.text-wrap {
  max-width: 80%;
  margin: 0 auto;
}

@media screen and (min-width: 1024px) {
  .text-wrap {
    max-width: 70%;
  }
}

</style>

